import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FilesService } from './services/files/files.service';
//import { ActiveProjectService } from '../shared/services/activeProject/activeProject.service';
import { PersonalFileInfo } from '../shared/models/PersonalFileInfo';
import { AlertService } from '../shared/services/alert/Alert.service';
import { ChunkedFileUploadComponent } from '../shared/components/chunkedFileUpload/chunkedFileUpload.component';
//import { UserPreferencesService } from '../shared/services/userpreferences/userPreferences.service';
import { RunningUploadsInfo } from './models/RunningUploadsInfo';
import { FileComponent } from './components/file/file.component';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { FilenameRequest } from '../shared/models/FilenameRequest';
import { DeleteFileDialogComponent } from './components/file/delete-file-dialog/delete-file-dialog/delete-file-dialog.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-files',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.css']
})
export class FilesComponent implements OnInit, AfterViewInit {
  @Input() clientHeight!: number;
  @Input() folder!: string;
  @Input() isUploadAllowed!: boolean;
  @Input() isSelectable!: boolean;
  @Input() isMultiselect!: boolean;
  @Input() useSingleFileAfterUpload!: boolean;
  @Input() userEmail!: string; // email of the user, for whom the files are loaded

  @Input() title!: string;
  @Input() filetypes!: string[];
  @Output() setFileInfo: EventEmitter<PersonalFileInfo> = new EventEmitter();
  @Output() setMultiFileInfo: EventEmitter<PersonalFileInfo[]> = new EventEmitter();
  @Output() setCountRunningUploads: EventEmitter<RunningUploadsInfo> = new EventEmitter();

  public is_deleteUsedFiles: boolean = false;
  public allSelected: boolean = false;
  public selectedInfo!: PersonalFileInfo;
  public countNewFiles: number = 0;
  public files: PersonalFileInfo[] = [];
  private tenantName: string = "";

  private countRunningUploads: number = 0;

  constructor(
    private FilesService: FilesService,
    private AlertService: AlertService,
    private tenantService: TenantService,
    public dialog: MatDialog,    
    // private activeProjectService: ActiveProjectService,
    // private userPreferencesService: UserPreferencesService
  ) { }

  ngAfterViewInit(): void {
    this.isMultiselect = this.isMultiselect || false;
    this.reload();
  }

  @ViewChildren('fileItems') fileItems!: QueryList<FileComponent>;
  @ViewChild('buttonline') buttonline!: ElementRef;
  @ViewChild('fileupload') fileupload!: ChunkedFileUploadComponent;
  @ViewChild('uploadarea') uploadarea!: ElementRef;


  onSetCountRunningUploads(info: RunningUploadsInfo) {
    this.countRunningUploads = info.countRunningUploads;
    if (this.useSingleFileAfterUpload && this.countRunningUploads > 1) {
      this.useSingleFileAfterUpload = false;
      this.AlertService.setWarning("Mehrfach-Upload, bitte die gewünschte Datei später manuell auswählen.");
    }
    this.setCountRunningUploads.emit(info);
  }

  ngOnInit() {
    let self = this;
    // self.reload();
    // if (self.userPreferencesService.currentPreferences) {
    //   self.is_deleteUsedFiles = self.userPreferencesService.currentPreferences.is_deleteUsedFiles;
    // }
  }

  public reload() {
    let self = this;
    let req = new FilenameRequest();
    req.folder = this.folder;
    req.userEmail = this.userEmail;
    //this.tenantName = (this.tenantService.currentTenantName) ? this.tenantService.currentTenantName : this.tenantName;
    console.log("------------> request: ", req  );
    this.tenantService.getPersonalFiles(this.tenantService.currentTenantName, req).subscribe({
      next: (files) => {

        console.log("-------------> files: ", files);
        self.files = files;
        self.recalcNewFiles();
      },
      error: (error: any) => {
        console.log("------> error: ", error.error);
               //self.AlertService.setError("Fehler beim Laden der Dateien: " + error.error);
      }
    });

    // self.FilesService.files(self.activeProjectService.projectId, self.folder, (files: PersonalFileInfo[]) => {
    //   self.files = files;
    //   self.recalcNewFiles();
    // });
  }

  private recalcNewFiles() {
    console.log("-------------> recalcNewFiles: files =",this.files);
    let countNewFiles = 0;
    for (let item of this.files) {
      if (item.isNew) countNewFiles++;
    }
    if (this.countNewFiles == countNewFiles) return;
    this.countNewFiles = countNewFiles;
  }

  toggleSelectAll(): void {
    if (!this.isMultiselect) return;
    if (this.allSelected) {
      this.deselectAll();
    } else {
      this.selectAll();
    }
    this.allSelected = !this.allSelected;
  }

  selectAll() {
    if (!this.isMultiselect) return;
    for (let item of this.files) {
      if (!this.isFileSupported(item)) continue;
      if (item.isNew) item.isChecked = true;
    }
  }

  downloadAll() {
    for (let file of this.files) {
      if (!this.isFileSupported(file)) continue;
      for (let item of this.fileItems) {
        item.download();
      }
    }
  }

  deleteAll() {
    let self = this;
    self.AlertService.confirm("Alle Dateien löschen? ",
      () => {
        self.deleteAllConfirmed();
      },
      () => { }
    );
  }

  deselectAll() {
    for (let item of this.files) {
      item.isChecked = false;
    }
  }

  applySelection() {
    const selectedItems = [];
    for (let item of this.files) {
      if (item.isChecked) {
        selectedItems.push(item);
      }
    }

    if (selectedItems.length == 0) {
      this.AlertService.setMessage("Keine Datei ausgewählt.");
      return;
    }

    this.setMultiFileInfo.emit(selectedItems);
  }

  countSelected(): number {
    let result = 0;
    for (let item of this.files) {
      if (item.isChecked) result++;
    }
    return result;
  }

  isFileSupported(file: PersonalFileInfo): boolean {
    let self = this;
    if (!this.filetypes || this.filetypes.length < 1) {
      return true
    }
    else {
      for (let ft of this.filetypes) {
        if (file.fileName.toLowerCase().endsWith("." + ft.toLowerCase())) {
          return true;
        }
      }
      return false;
    }
  }

  onDelete(file: PersonalFileInfo) {
    console.log("-------------> onDelete: file = ", file);
    let self = this;
    let req = new FilenameRequest();
    req.folder = this.folder;
    req.userEmail = this.userEmail;
    req.filename = file.fileName;

    // if (file.isNew) {
    //   // console.log("-------------> deleteItem: Datei ist neu und wurde noch nicht heruntergeladen!");
    //   self.AlertService.confirm("Datei wurde noch nicht herungergeladen. Löschen? ",
    //     () => {
    //     self.AlertService.setOk("Datei " + file.fileName + " gelöscht!");
    //     },
    //     () => {}
    //   );
    // } else
    // {
    //     self.AlertService.setOk("Datei " + file.fileName + " gelöscht!");
    // }

    if (file.isNew) {
      const dialogRef = this.dialog.open(DeleteFileDialogComponent, {width: '500px',data:{fileInfo: file} }); 
      dialogRef.afterClosed().subscribe((result:any) => {

      if(result != undefined){
        this.deleteFile(req);
      }
    });    

    }
    else {
      this.deleteFile(req);
    }
    //this.tenantName = (this.tenantService.currentTenantName) ? this.tenantService.currentTenantName : this.tenantName;
  }

  deleteFile(req: FilenameRequest) {
    let self = this;
    self.tenantService.deletePersonalFile(this.tenantService.currentTenantName, req).subscribe({
      next: (result) => {
      if (result) {
        self.AlertService.setOk("Datei " + req.filename + " gelöscht!");
        self.reload();
      }
      else {
        self.AlertService.setWarning("Datei " + req.filename + " konnte nicht gelöscht werden!");
      }
      },
      error: (error: any) => {
        console.log("------> error: ", error.error);
        self.AlertService.setError("Fehler beim Löschen der Datei: " + error.error);
      }
    });
  }

  onClick(file: PersonalFileInfo) {
    let self = this;
    if (self.isSelectable) {
      self.selectedInfo = file;
      self.setFileInfo.emit(file);
      return;
    }
  }

  onFirstDownload(file: PersonalFileInfo) {
    let self = this;
    self.recalcNewFiles();
  }

  onDeleteRead() {
    let self = this;
    let req = new FilenameRequest();
    req.folder = this.folder;
    req.userEmail = this.userEmail;
    //this.tenantName = (this.tenantService.currentTenantName) ? this.tenantService.currentTenantName : this.tenantName;
    let newFiles: PersonalFileInfo[] = [];
    var countDeleted = 0;
    for (let file of self.files) {
      console.log("onDeleteRead: file = ", file);
      if (!self.isFileSupported(file)) continue;
      if (file.isNew) {
        newFiles.push(file);
      } else {
        countDeleted++;
        console.log("onDeleteRead: delete file = ", file);
        req.filename = file.fileName;
        this.tenantService.deletePersonalFile(this.tenantService.currentTenantName, req).subscribe({
          next: (result) => {
          // if (result) {
          //   self.AlertService.setOk("Datei " + file.fileName + " gelöscht!");
          //   self.reload();
          // }
          // else {
          //   self.AlertService.setWarning("Datei " + file.fileName + " konnte nicht gelöscht werden!");
          // }
          },
          error: (error: any) => {
            console.log("------> error: ", error.error);
            self.AlertService.setError("Fehler beim Löschen der Datei: " + error.error);
          }
        });
      }
    }
    self.showCountDeleted(countDeleted);
    self.files = newFiles;
  }

  onSetFileInfo(info: PersonalFileInfo) {
    this.reload();
    this.fileupload?.onClear(false);
    if (this.useSingleFileAfterUpload) {
      this.onClick(info);
    }
  }

  showCountDeleted(countDeleted: number) {
    let self = this;
    if (countDeleted == 1) {
      self.AlertService.setOk("" + countDeleted + " Datei gelöscht!");
    }
    else if (countDeleted > 0) {
      self.AlertService.setOk("" + countDeleted + " Dateien gelöscht!");
    }
  }

  deleteAllConfirmed() {
    let self = this;
    let countDeleted = self.files.length;

    if (this.filetypes && this.filetypes.length > 0) {
      countDeleted = 0;
      for (let file of self.files) {
        if (!self.isFileSupported(file)) continue;
        countDeleted++;
        self.FilesService.deletePersonalFile("1234", self.folder, file.fileName, (result: boolean) => {
        });
      }
      self.showCountDeleted(countDeleted);
      self.files = [];
    } else {
      self.FilesService.deletePersonalFiles("1234", self.folder, (result: boolean) => {
        if (result) {
          self.showCountDeleted(countDeleted);
          self.reload();
        }
        else {
          self.AlertService.setWarning("Dateien konnten nicht gelöscht werden!");
        }
      });
    }
  }

}
